import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class EformElementsService {
	updateIdsRecursively(elements: any[], index: number[], isSubSection: boolean = false) {
    if (elements == null) {
      return elements;
    }

    elements.forEach(element => {
      let elementRepeatedId = [...index];
      if (element.id.includes("_")) {
        if (element.id.split("_").length > elementRepeatedId.length + 1) {
          elementRepeatedId.push(element.id.split("_").slice(-1)[0]);
        }
      } else {
        if (element._repeatable) {
          elementRepeatedId.push(0);
        }
      }
      element.id = element.id.split("_")[0];
      if (elementRepeatedId[0] !== 0) {
        elementRepeatedId.forEach((id) => {
          element.id += "_" + id;
        })
      } else if (elementRepeatedId.slice(-1)[0] != 0) {
        element.id += "_" + elementRepeatedId.slice(-1)[0];
      }

      if (element.groups) {
        element.groups = this.updateIdsRecursively(element.groups, [...elementRepeatedId], isSubSection);
      }
      // Recherche les subGroups avec un ou plusieurs "sub" (subSubGroups, etc.)
      let subGroups = Object.keys(element).filter(function (str: string) {return /sub.*Groups?/.test(str); });
      if (subGroups != null) {
        subGroups.forEach(subGroup => {
          element[subGroup] = this.updateIdsRecursively(element[subGroup], [...elementRepeatedId], isSubSection);
        });
      }
      if (isSubSection && element.fields != null) {
        element.fields.forEach(field => field.isNewFromSameStep = true);
      }
    })

    return elements;
  }

  clearRepeatedGroups(elements: any[]) {
    if (elements == null) {
      return elements;
    }

    elements = elements.filter((element) => !element.repeatedId || element.repeatedId.slice(-1)[0] === 0);

    for (let element of elements) {
      if (element.groups) {
        element.groups = this.clearRepeatedGroups(element.groups);
      }

      element.deletable = false;

      // Recherche les subGroups avec un ou plusieurs "sub" (subSubGroups, etc.)
      let subGroups = Object.keys(element).filter(function (str: string) {return /sub.*Groups?/.test(str); });
      if (subGroups != null) {
        for (let subGroup of subGroups) {
          element[subGroup] = this.clearRepeatedGroups(element[subGroup]);
        }
      }
    }

    return elements;
  }
}
